<template>
  <div>
      <van-tabbar v-model="active" active-color="skyblue">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="logistics" @click="handle"
          >货车ETC</van-tabbar-item
        >
      </van-tabbar>
  </div>
</template>
<script>
// import axios from "axios";
import { Toast } from "vant";
export default {
  name: "TabBar",
  data() {
    return {
      active: 0,
      // xjEtcUrl: 'http://localhost:8080?customerSrc=3&channelNo=ysf',
      mobile: localStorage.getItem('customerMobile'),
    };
  },
  methods: {
    handle() {
      // if (this.mobile !== undefined && this.mobile !== null && this.mobile !== '') {
      //   window.location.href = `https://h5.mot-jk.com?customerSrc=2&channelNo=ysf&mobile=${this.mobile}`;
      // } else {
      //     Toast({
      //       message: "您还未登录，请先点击上方去登陆",
      //       duration: 3000
      //     }); 
      // }
      
      if( window.localStorage.getItem("token") > 1) {
        window.location.href = `https://h5.mot-jk.com?customerSrc=2&channelNo=ysf&mobile=${this.mobile}`;
        // window.location.href = `http://localhost:8080?customerSrc=2&channelNo=ysf&mobile=${this.mobile}`;
      } else {
          Toast({
            message: "您还未登录，请先点击上方去登陆",
            duration: 3000,
          }); 
      }
    }
  }
}; 
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue